import { PaymentChannelType } from '../../../shopkeeper/common/enums/payment-channel-type.enum';
import { BrandIntegrationType } from '../enums/brand-integration-type.enum';

export class Brand {
  displayName: string;
  email?: string;
  address?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  redirectionUrl?: string;
  skuName?: string;
  logoUrl?: string;
  portalUrl?: string;
  zeroMessage?: string;
  appDownloadUrl?: string;
  hasBlankSims?: boolean;
  integrationType: BrandIntegrationType;
  appPackages?: string[];
  supportNumber: string;
  supportNumberOpeningHours: string;
  supportEmail: string;
  zeroMessageNoIdentifier: string;
  isExternalIdRequired: boolean;
  isAddressRequired: boolean;
  isEmailRequired: boolean;
  isCurpRequired?: boolean;
  isCurpEnabled: boolean;
  isNameRequired: boolean;
  paymentChannelTypes: PaymentChannelType[];
  megaPointName: string;
}
